import { render, staticRenderFns } from "./modal-connection.vue?vue&type=template&id=20ada4ef"
import script from "./modal-connection.ts?vue&type=script&lang=js&external"
export * from "./modal-connection.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports